// import toastr from '../../../../../bower_components/toastr/toastr';
import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/popover';
import toastrNode from 'toastr/build/toastr.min';
import {setToastr} from './toastr';

function estimeCoutCarteGrise(toastr)
{

    var $calculCarteGriseDepartement = $('#calculCarteGriseDepartement');
    var departement = $calculCarteGriseDepartement.val();
    var carId = $calculCarteGriseDepartement.data('id');

    if (departement.match(/^[0-9]{1}$/)){
        departement = '0' + departement;
    }

    $('.resultCarteGrise').fadeOut(function () {
        $('.loadingCarteGrise').fadeIn();

        $.ajax({
            url: $calculCarteGriseDepartement.data('path'),
            method: 'POST',
            dataType: 'JSON',
            data: {
                department: departement,
                carId: carId
            }
        })
        .done(function (data) {
            const formatterNumber = new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'});
            if (data && data.length === 2 && data[0].carRegistrationDocumentEstimation !== data[1].carRegistrationDocumentEstimation) {
                $('.loadingCarteGrise').fadeOut(function () {
                    $('#estimationCarteGriseMontantStart').html(formatterNumber.format(Number(data[0].carRegistrationDocumentEstimation)));
                    $('#estimationCarteGriseMontantEnd').html(formatterNumber.format(Number(data[1].carRegistrationDocumentEstimation)));
                    $('#estimationCarteGriseDepartement').html(departement);
                    $('.resultCarteGrise').fadeIn();
                });
            } else if (data) {
                $('.loadingCarteGrise').fadeOut(function () {
                    $('#estimationCarteGriseMontant').html(formatterNumber.format(Number(data[0].carRegistrationDocumentEstimation)));
                    $('#estimationCarteGriseDepartement').html(departement);
                    $('.resultCarteGrise').fadeIn();
                });
            }


        }).fail(function () {

            $('.loadingCarteGrise').fadeOut(function () {

                setToastr(toastr, 'Oops, une erreur est survenue, veuillez réessayer dans quelques instants', 'error');

            });

        });

    });

}

$(document).ready(function (){

    $('#calculCarteGriseBouton').click(function (){

        estimeCoutCarteGrise(toastrNode);

    });

    $('#calculCarteGriseDepartement').focus(function (event){
        $(event.currentTarget).popover('destroy');
    })
    .keydown(function (event){

        if (event.keyCode === 13){
            estimeCoutCarteGrise(toastrNode);
        }

    });

});
